<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :clearable="clearable"
      :filterable="filterable"
      :placeholder="placeholder"
      :size="size"
      @change="handleChange"
    >
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { voucherStatuses } from '@/enums/voucherStatuses';

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    clearable: Boolean,
    filterable: Boolean,
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    placeholder: {
      type: String,
      default: '请选择状态',
    },
  },
  data: () => ({
    valueBackup: '',
    list: voucherStatuses,
  }),
  watch: {
    value(value) {
      // 外部传入 0 时转换为空字符串，使 el-select 显示 placeholder 而非 "0"
      const normalized = value || '';
      if (normalized !== this.valueBackup) this.valueBackup = normalized;
    },
    valueBackup(valueBackup) {
      // 空字符串还原为 0 再发送给父组件
      const emitValue = valueBackup || 0;
      if (emitValue !== (+this.value || 0)) this.$emit('input', emitValue);
    },
  },
  methods: {
    handleChange(valueBackup) {
      this.$emit('change', valueBackup || 0);
    },
  },
  beforeMount() {
    this.valueBackup = this.value || '';
  },
};
</script>
